import React from "react";

function Works() {
  return (
    <div>
      <h2>Works</h2>
    </div>
  );
}

export default Works;
